import React from 'react';
import { getLocale } from 'umi';
import { LANGUAGE_EN } from "@home/_config/config";

const IframeGuard: React.FC = ({ children }) => {
  if (window.self === window.top) {
    const isEn = getLocale() === LANGUAGE_EN;
    return (
      <div style={{marginTop: '300px', display: 'flex', justifyContent: 'center' }}>
        {isEn ? 'The content is not embedded in an iframe. Access denied.' : '没有嵌入在iframe中，无权访问'}
      </div>
    );
  }
  return <>{children}</>;
};

export default IframeGuard;